/** Ruta inexistente. Ofrece la salida (inicio) en vez de dejar la pantalla vacia. */

import { Link } from 'react-router-dom';

import { EmptyState } from '@/components/shell/primitives';

export function NotFoundPage() {
  return (
    <EmptyState
      title="Esta pantalla no existe"
      description="El enlace puede estar viejo, o el módulo que la definía ya no está instalado en esta empresa."
      action={
        <Link
          to="/"
          className="inline-flex h-10 items-center rounded-md bg-accent px-4 text-sm font-medium text-accent-contrast transition-colors hover:bg-accent-hover"
        >
          Volver al inicio
        </Link>
      }
    />
  );
}
